/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_4Inputs */

const da_privacy_retention_4 = /** @type {(inputs: Privacy_Retention_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log over administratorers handlinger og over betalinger: fem år.`)
};

/** @type {(inputs: Privacy_Retention_4Inputs) => LocalizedString} */
const en_privacy_retention_4 = da_privacy_retention_4;

/**

* @param {Privacy_Retention_4Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_4 = /** @type {((inputs?: Privacy_Retention_4Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_4Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_4(inputs)
	return /** @type {LocalizedString} */ ("Log over administratorers handlinger og over betalinger: fem år.")
});